const getFormData = ( data = {} ) => {
    const formData = new FormData();
    for( let prop in data ){
        formData.append( prop, data[ prop ] );
    }

    return formData ;
}

const setLangMeta = ( content ) => {
    if( !( Array.isArray( content.langmeta ) && content.langmeta.length ) )return content;
    const langmeta = content.langmeta[ 0 ];
    content.title = langmeta.title ;
    content.description = langmeta.description ;
    return content;  
}

export {
    getFormData,
    setLangMeta
}